<div class="p-grid">
    <div class="p-col-12">
        <div class="">
            <h5 class="head-page-title">
                Add User
            </h5>
            <!-- <button pButton pRipple label="Back" icon="pi pi-arrow-left" class="p-button-primary" 
                (click)="backLink()"></button> -->
        </div>
        <div class="card p-pt-3">
            <p-toast key="toastmsg" position="top-right"></p-toast>
            <form [formGroup]="userForm" *ngIf="this.userForm" (ngSubmit)="onSubmit()">
                <div class="p-fluid p-formgrid p-grid pare_margin">
                    <div class="p-field p-col-12 div-border">
                        <h5 class="p-mb-3">
                            Add User Details
                        </h5>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="firstName">First Name <span class="mandatory-feilds">*</span></label>
                        <input formControlName="firstName" type="text" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }">
                        <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                            <div *ngIf="f.firstName.errors.required">First Name is required</div>
                            <div *ngIf="f.firstName.errors">Numbers, Space and Special characters not allowed.</div>
                        </div>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="lastName">Last Name <span class="mandatory-feilds">*</span></label>
                        <input formControlName="lastName" type="text" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }">
                        <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                            <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                            <div *ngIf="f.lastName.errors">Numbers, Space and Special characters not allowed.</div>
                        </div>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="email">Email Id <span class="mandatory-feilds">*</span></label>
                        <input formControlName="email" type="email" pInputText
                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                            <div *ngIf="f.email.errors.email">Enter Valid Email Address</div>
                        </div>
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-4">
                        <label>Password <span class="mandatory-feilds">*</span></label>
                        <input type="password" formControlName="password" pInputText
                            [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required">Password is required</div>
                            <div *ngIf="f.password.errors.minlength">Password Must Be At Least 6 Characters</div>
                        </div>
                    </div>
                    <div class="p-field p-col-4">
                        <label>Confirm Password <span class="mandatory-feilds">*</span></label>
                        <input type="password" formControlName="confirmPassword" pInputText
                            [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
                        <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                            <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required</div>
                            <div *ngIf="f.confirmPassword.errors.mustMatch">Passwords Must Match</div>
                        </div>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="mobileNumber">Mobile Number <span class="mandatory-feilds">*</span></label>
                        <input formControlName="mobileNumber" minlength="10" maxlength="12" type="text" pInputText
                            class="form-control" [ngClass]="{ 'is-invalid': submitted && f.mobileNumber.errors }">
                        <div *ngIf="submitted && f.mobileNumber.errors" class="invalid-feedback">
                            <div *ngIf="f.mobileNumber.errors.required">Mobile Number is required</div>
                            <div *ngIf="f.mobileNumber.errors">Please Check Mobile Number</div>
                        </div>
                    </div>
                    <input formControlName="disable" type="hidden" value="No">
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-4">
                        <label for="country">Country <span class="mandatory-feilds">*</span></label>
                        <!-- <select class="custom-select" formControlName="country" (change)="getStates($event)">
                            <option value="">Choose your Country</option>
                            <option *ngFor="let item of countryList" [value]="item.iso2">{{item.name}}</option>
                        </select> -->
                        <p-dropdown inputId="country" [options]="countrylist" formControlName="country" [filter]="true"
                            (onChange)="getStates($event)" placeholder="Select" optionLabel="name"
                            [ngClass]="{ 'is-invalid': submitted && f.country.errors }"></p-dropdown>
                        <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                            <div *ngIf="f.country.errors.required">Please Select Country</div>
                        </div>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="state">State</label>
                        <!-- <select class="custom-select" formControlName="state" (change)="getCities($event)">
                            <option value="">Choose your State</option>
                            <option *ngFor="let item of stateList" [value]="item.state_code">{{item.name}}</option>
                        </select> -->
                        <p-dropdown inputId="state" [options]="statelist" formControlName="state" [filter]="true"
                            (onChange)="getCities($event)" placeholder="Select" optionLabel="name"></p-dropdown>

                    </div>
                    <div class="p-field p-col-4">
                        <label for="city">City</label>
                        <!-- <select class="custom-select" formControlName="city">
                            <option value="">Choose your City</option>
                            <option *ngFor="let item of cityList" [value]="item.name">{{item.name}}</option>
                        </select> -->
                        <p-dropdown inputId="city" [options]="citylist" formControlName="city" [filter]="true"
                            placeholder="Select" optionLabel="name" (onChange)="onCitySelect($event)"></p-dropdown>

                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-4">
                        <label for="textarea">Address</label>
                        <textarea inputId="textarea" rows="3" cols="30" class="form-control" formControlName="address"
                            pInputTextarea></textarea>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="zipcode">Zipcode</label>
                        <input formControlName="zipcode" type="text" maxlength="10" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.zipcode.errors }">
                    </div>
                    <div class="p-field p-col-4">
                        <label for="status">Status</label>
                        <p-dropdown inputId="status" [options]="statuses" formControlName="status" placeholder="Select"
                            optionLabel="label" (ngModelChange)="onStatusSelect($event)"></p-dropdown>
                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                            <div *ngIf="f.status.errors.required">Please Select Status</div>
                        </div>
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-4">
                        <label for="textarea">Gender <span class="mandatory-feilds">*</span></label>
                        <p-dropdown inputId="gender" [options]="genders" formControlName="gender" placeholder="Select"
                            optionLabel="name" (ngModelChange)="onGenderSelect($event)"
                            [ngClass]="{ 'is-invalid': submitted && f.gender.errors }"></p-dropdown>
                        <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                            <div *ngIf="f.gender.errors.required">Please Select Gender</div>
                        </div>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="dob">DOB <span class="mandatory-feilds">*</span></label>
                        <!-- <p-calendar #pCalendarId  class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"  [(ngModel)]="calvalue" ></p-calendar> -->
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="{{yearRange}}"
                            formControlName="dob" class="p-calendar" inputId="calendar" [defaultDate]="date"
                            dateFormat="dd/mm/yy" [showIcon]="true"
                            [ngClass]="{ 'is-invalid': submitted && f.dob.errors }"></p-calendar>
                        <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                            <div *ngIf="f.dob.errors.required">Please Enter DOB</div>
                        </div>
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-4">
                        <p-fileUpload chooseLabel="Upload Profile Photo" uploadLabel="Show data" cancelLabel="Cancel"
                            accept="image/*" maxFileSize="1000000" auto="auto" customUpload="true"
                            (uploadHandler)="picUploader($event)">
                            <ng-template pTemplate="content">

                            </ng-template>
                        </p-fileUpload>
                    </div>
                </div>
                <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end">
                    <div class="p-formgrid p-grid">
                        <button pButton pRipple label="Save" icon="pi pi-check"
                            class="p-button-success save-btn p-mr-3"></button>
                        <!-- <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="userForm.invalid"></button> -->
                        <button pButton pRipple label="Reset" icon="pi pi-times" type="reset" (click)="onReset()"
                            class="p-mr-3"></button>
                        <button pButton pRipple type="button" label="Back" class="p-button-info"
                            (click)="backLink()"></button>
                    </div>
                </div>
            </form>
        </div>
        <div class="button-set back">
            <div class="p-fluid p-formgrid">
                <p-toast></p-toast>
            </div>
        </div>
    </div>
</div>